<template>
<section id="partners">
    <div class="container">
        <div class="columns partners">
            <div class="column">
                <div class="columns">
                    <div class="column">
                        <h2 class="title partners">
                            {{$t('DevelopedWith')}}
                        </h2>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="columns">
                            <div class="column is-4 has-text-centered">
                                <img src="../assets/images/partners/dierenkliniek_den_ham.png" alt="Dierenklinken Den Ham">
                            </div>
                            
                            <div class="column is-4 has-text-centered">
                                <img src="../assets/images/partners/dierenkliniek_emmeloord.png" alt="Dierenkliniek Emmeloord">
                            </div>
                            <div class="column is-4 has-text-centered ">
                                <img  src="../assets/images/partners/logo_sporthorse.png" >
                            </div>
                            
                            <!-- <div class="column is-3">
                                <img  src="../assets/images/logo_login.png" >
                            </div> -->
                        </div>
                        <div class="columns partner-column">
                            <div class="column is-4 has-text-centered ">
                                <img  src="../assets/images/partners/freestyle_academy_logo_groen.png" style="width: 60%;" >
                            </div>
                            <div class="column is-4 has-text-centered ">
                                <img src="../assets/images/partners/horses_hands.png" alt="Horses in Hands">
                            </div>
                            <div class="column is-4 has-text-centered ">
                                <img  src="../assets/images/partners/logo-lingehoeve1.png"  >
                            </div>
                            
                        </div>
                        <div class="columns partner-column">
                            <div class="column is-4 has-text-centered ">
                                <img  src="../assets/images/partners/logoraaphorst.jpg" >
                            </div>
                            <div class="column is-4 has-text-centered ">
                                <img src="../assets/images/partners/prNHlogo.png" alt="Horses in Hands">
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
  
</template>

<script>
export default {
    name: 'Partners',
    
}
</script>

<style>

</style>